import styled from "styled-components";

export const OnboardingDialogStepIndicatorBox = styled.div<{activeStep?: boolean;}>`
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${({theme}) => theme.colors.brandPrimaryLight};
    margin-right: 3px;
    opacity: ${({activeStep}) => activeStep ? 1 : 0.5};
`;
